"use strict";

exports.__esModule = true;
exports.isTouchDevice = exports.isMobileAgent = exports.getDeviceType = void 0;

/* Check user agent string for Android or iOS client */
var isMobileAgent = function isMobileAgent() {
  if (typeof window === 'undefined') {
    return false;
  }

  var userAgent = typeof window !== 'undefined' && window.navigator && (window.navigator.userAgent || window.navigator.vendor || window.opera);
  return /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

exports.isMobileAgent = isMobileAgent;

var isTouchDevice = function isTouchDevice() {
  return typeof window !== 'undefined' && window.navigator && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0);
};

exports.isTouchDevice = isTouchDevice;

var getDeviceType = function getDeviceType() {
  if (typeof window === 'undefined') {
    return false;
  }

  var ua = typeof window !== 'undefined' && window.navigator && (window.navigator.userAgent || window.navigator.vendor || window.opera);

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }

  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile';
  }

  return 'desktop';
};

exports.getDeviceType = getDeviceType;